export default "__VITE_ASSET__BHcSWs7Y__"